import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import API from '../Services/Product'
import ProductType from "../Components/ProductType";
import TaxRateListList from "../Components/TaxRate";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import APIS from '../Services/SalesTab'
import APISS from '../Services/Location'
import APISSS from '../Services/ProductType'
import APIMACHINE from '../Services/MachineMaster'
import DisplayOrder from '../Components/DisplayOrder'

const ComboProduct = ({ fetchDetails }) => {
    const [showSingleModal1, setShowSingleModal1] = useState(false);
    const [showComboModal1, setShowComboModal1] = useState(false);

    const [name, setName] = useState("")
    const [productType, setProductType] = useState([])
    const [displayOrder, setDisplayOrder] = useState([])
    const [playPoint, setPlayPoint] = useState("")
    const [description, setDescription] = useState("")
    const [isRecipe, setIsRecipe] = useState("")
    const [error, setError] = useState({});
    const [productList, setProductList] = useState([])
    const perPage = 10
    const [id, setId] = useState([])
    const [isEditing, setIsEditing] = useState(false);
    const [highlight, setHighlight] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const [comboName, setComboName] = useState("")
    const [comboProductType, setComboProductType] = useState([])
    const [comboDisplayOrder, setComboDisplayOrder] = useState([])
    const [comboPrice, setComboPrice] = useState("")
    const [comboTax, setComboTax] = useState("")
    const [singleTax, setSingleTax] = useState("")
    const [comboTime, setComboTIme] = useState("min")
    const [rows, setRows] = useState([]);
    const [searchProductType, setSearchProductType] = useState([])
    const [currentPage1, setCurrentPage1] = useState(1);
    const [totalRecords1, setTotalRecords1] = useState(0);
    const [searchProductList, setSearchProductList] = useState([])
    const [selectTime, setSelectTime] = useState([])
    const [qty, setQty] = useState("")
    const [timeOptions, setTimeOptions] = useState([]);
    const [isCombo, setISCombo] = useState("")
    const [isEditingCombo, setIsEditingCombo] = useState(false);
    const [isAddProductList, setIsAddProductList] = useState(true);
    const [isModal, setIsModal] = useState(false)
    const [salesTab, setSalesTab] = useState([])
    const [salesTab1, setSalesTab1] = useState([])
    const [selectSalesTab, setSelectSalesTab] = useState(null)
    const [updateProductType, setupdateProductType] = useState([])
    const [selectedLocation, setSelectedLocation] = useState("")
    const [selectedLocation1, setSelectedLocation1] = useState("")
    const [location, setLocation] = useState([])
    const [location1, setLocation1] = useState([])
    const [selectcomboSalesTab, setSelectcomboSalesTab] = useState("")
    const [selectedcomboProductType, setSelectedcomboProductType] = useState([])
    const [changePlayPoint, setChangePlayPoint] = useState("SkyCoins")
    const [timeValue, setTimeValue] = useState(Number);
    const [timeValue1, setTimeValue1] = useState(Number);
    const [curiousKids, setCuriousKids] = useState("")
    const [selectMachine, setSelectMachine] = useState("");
    const [machine, setMachine] = useState([])
    const [mrp, setMrp] = useState("");
    const [enableParty, setEnableParty] = useState("")
    const [refresh, setRefresh] = useState(true);
    const [skycoinsSpcl, setSkycoinsSpcl] = useState();
    const [comboSpecialPrice, setComboSpecialPrice] = useState(0);
    const [trackInventory, setTrackInventory] = useState(false);
    useEffect(() => {
        getTimeData()
    }, [currentPage])

    const handleChange1 = (e) => {
        const value = e.target.value;
        setSelectedLocation(value);
        getSalesTab(value)
        setSelectSalesTab(value);
        getMachine(value);
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.salesTab;
            return updatedErrors;
        });
    };


    const handleChange3 = (e) => {
        setRefresh(false);
        const value = e.target.value;
        setSelectedLocation1(value);
        getSalesTab1(value)
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.salesTab;
            return updatedErrors;
        });
    };


    const handleChange = async (e) => {
        const value = e.target.value;
        if (value === 'Select') {
            setSelectSalesTab(0);
            setChangePlayPoint("Play Point");
        } else {
            setSelectSalesTab(value);
            const payload = {
                is_active: 1,
                id: e.target.value,
                limit: 0,
                pageNumber: 1,
            }
            const response = await APIS.Sales_Tab_List(payload)
            setChangePlayPoint(response?.data?.data[0]?.price_type)

        }
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.salesTab;
            return updatedErrors;
        });
    };


    const handleChange2 = (e) => {
        const value = e.target.value;
        if (value === 'Select') {
            setSelectcomboSalesTab(0);
        } else {
            setSelectcomboSalesTab(value);
            bindComboProduct(value)

        }

        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.salesTab;
            return updatedErrors;
        });
    };

    const handleChange4 = (e) => {
        const value = e.target.value;
        setSelectedcomboProductType(value);
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.salesTab;
            return updatedErrors;
        });
    };


    useEffect(() => {
        bindLocation()
    }, [])

    const bindLocation = async () => {
        try {
            const response = await APISS.getLocationList({
                is_active: 1,
                limit: 0,
            });
            setLocation(response?.data?.data || []);
            setLocation1(response?.data?.data || [])
        } catch (error) {
            setError("Failed to fetch locations.");
            console.error(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    const getSalesTab = async (location) => {
        try {
            if (location === "Select") {
                // console.log('ddd')
                setSalesTab([]);
                return;
            }
            const response = await APIS.Sales_Tab_List({
                is_active: 1,
                limit: 10,
                pageNumber: 1,
                search: location,
            });
            setSalesTab(response?.data?.data || []);
        } catch (error) {
            setError((prev) => ({ ...prev, salesTab: "Failed to fetch sales tab data." }));
            handleError(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    const getMachine = async (locationid) => {
        try {
            if (location === "Select") {
                setMachine([]);
                return;
            }
            const payload = {
                location_id: locationid,
                is_active: 1
            }
            const response = await APIMACHINE.getMachineDetail(payload);
            setMachine(response?.data?.data || []);
        } catch (error) {
            setError((prev) => ({ ...prev, machine: "Failed to fetch machine data." }));
            handleError(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }

    }
    const getSalesTab1 = async (location) => {
        try {
            if (location === "Select") {

                setSalesTab1([]);
                return;
            }
            const response = await APIS.Sales_Tab_List({
                is_active: 1,
                limit: 10,
                pageNumber: 1,
                search: location,
            });
            setSalesTab1(response?.data?.data || []);
            setRefresh(true);
        } catch (error) {
            setError((prev) => ({ ...prev, salesTab: "Failed to fetch sales tab data." }));
            handleError(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };
    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        //console.log("value data", value)
        setComboTIme(value)
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "name":
                setName(value);
                break;
            case "productType":
                setProductType(value);
                break;
            case "displayOrder":
                setDisplayOrder(value);
                break;
            case "playPoint":
                setPlayPoint(value);
                break;
            case "description":
                setDescription(value);
                break;
            case "comboTime":
                setComboTIme(value);
                break;
            case "timeValue":
                setTimeValue(value);
                break;
            case "mrp":
                setMrp(value);
                break;
            case "timeValue1":
                setTimeValue1(value);
                break;
            case "singleTax":
                setSingleTax(value);
                break;
            case "skycoinsSpcl":
                setSkycoinsSpcl(value);
                break;
            case "selectMachine":
                setSelectMachine(value);
                if (value === "Select") {
                    // setSelectMachine(null);
                    setSelectMachine("");
                    setIsRecipe(false);
                }
                else {
                    setSelectMachine(value);
                }
                break;
            default:
                break;
        }
    };

    const validateFields = () => {
        const errors = {};
        if (!name.trim()) errors.name = "Name is required";
        if (!playPoint.trim()) {
            errors.playPoint = "Play point is required";
        } else if (!/^\d+$/.test(playPoint.trim())) {
            errors.playPoint = "Play point must be a numeric value";
        } else if (parseInt(playPoint, 10) === 0) {
            errors.playPoint = "Play point must be greater than 0";
        }
        setError(errors);
        return Object.keys(errors).length === 0;
    };


    const handleError = (error) => {

        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");

        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };


    useEffect(() => {
        if (searchProductType) {
            handleSearch(searchProductType, currentPage1);
        }
    }, [currentPage1]);


    const handleSearch = async (product_type_id, page) => {
        if (!product_type_id || product_type_id.length === 0) {
            return;
        }
        setIsModal(true);
        const payload = {
            limit: perPage,
            pageNumber: page,
            product_type_id: product_type_id,
        };
        try {
            const response = await API.Get_Product(payload);

            if (response.data && response.data.data) {
                setSearchProductList(response.data.data);
                setTotalRecords1(response.data.totalCount);
                setIsModal(true);
            } else {
                toast.error("No data found.");
            }
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.error('Error fetching products:', error);
            toast.error("An error occurred while searching for products.");
        }
    };
    const handleSearchClick = () => {
        if (!searchProductType || searchProductType.length === 0) {
            toast.error("Please select a Product Type.");
            return;
        }
        handleSearch(searchProductType, currentPage1);
    };

    const totalPages1 = Math.ceil(totalRecords1 / perPage);
    const handlePageChange1 = (page) => {
        if (page > 0 && page <= totalPages1) {
            setCurrentPage1(page);
            handleSearch(searchProductType);
            //getProductList();
        }
    };
    const handleInputChange = (index, field, value) => {
        const updatedRows = rows.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        );
        setRows(updatedRows);

        if (field === "discounted_price" || field === "qty") {
            const total = updatedRows.reduce((sum, row) => {
                const price = parseFloat(row.discounted_price || 0);
                const qty = parseFloat(row.qty);
                const validQty = isNaN(qty) || qty === 0 ? 1 : qty;
                const rowTotal = price * validQty;
                return sum + (isNaN(rowTotal) ? 0 : rowTotal);
            }, 0);

            setComboPrice(total.toFixed(2));
        }
        if (field === "discounted_price_special" || field === "qty") {
            const total = updatedRows.reduce((sum, row) => {
                const price = parseFloat(row.discounted_price_special || 0);
                const qty = parseFloat(row.qty);
                const validQty = isNaN(qty) || qty === 0 ? 1 : qty;

                const rowTotal = price * validQty;
                return sum + (isNaN(rowTotal) ? 0 : rowTotal);
            }, 0);

            setComboSpecialPrice(total.toFixed(2));
        }
    };
    const handleFieldChange1 = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "comboName":
                setComboName(value);
                break;
            case "comboProductType":
                setComboProductType(value);
                break;
            case "comboDisplayOrder":
                setComboDisplayOrder(value);
                break;
            case "comboPrice":
                setComboPrice(value);
                break;
            case "comboTax":
                setComboTax(value);
                break;
            // case "comboTime":
            //     setComboTIme(value);
            //     break;
            default:
                break;
        }
    };
    const validateFields1 = () => {
        const errors = {};
        if (!comboName.trim()) errors.comboName = "Name is required";
        if (!comboPrice.trim()) {
            errors.comboPrice = "Price is required";
        } else if (isNaN(comboPrice)) {
            errors.comboPrice = "Price must be a valid number";
        } else if (parseFloat(qty) <= 0) {
            errors.comboPrice = "Price must be greater than 0";
        }
        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const recalculateComboPrices = (rowsData) => {
        const totalNormal = rowsData.reduce((sum, row) => {
            const price = parseFloat(row.discounted_price || 0);
            const qty = parseFloat(row.qty || 1);
            return sum + price * (qty === 0 ? 1 : qty);
        }, 0);

        const totalSpecial = rowsData.reduce((sum, row) => {
            const price = parseFloat(row.discounted_price_special || 0);
            const qty = parseFloat(row.qty || 1);
            return sum + price * (qty === 0 ? 1 : qty);
        }, 0);

        setComboPrice(totalNormal.toFixed(2));
        setComboSpecialPrice(totalSpecial.toFixed(2));
    };

    const handleRemoveRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
        recalculateComboPrices(updatedRows)
    };

    const handleAddRow = async (id, productName, time, type) => {
        const isAlreadyAdded = rows.some(row => row.id === id);
        if (isAlreadyAdded) {
            toast.error("Product already added");
            return;
        }
        console.log(time);
        if (type === 'up') {
            try {
                const response = await API.getSubProduct(id);
                //console.log("response data product data update..", response)
                const details = response?.data?.data?.rows || [];
                if (details.length === 0) {
                    console.warn("No sub-products found");
                    return;
                }
                const newRows = details.map(item => {
                    const totalMinutes = item.time ?? null;

                    const hours = totalMinutes !== null ? Math.floor(totalMinutes / 60) : "";
                    const minutes = totalMinutes !== null ? totalMinutes % 60 : "";

                    return {
                        id: item.product_id,
                        productName: item.product_name,
                        time: totalMinutes ?? 0, // keep numeric for logic check
                        hours,
                        minutes,
                        qty: item.quantity ?? "0",
                        discounted_price: item.offered_price,
                        discounted_price_special: item.special_price
                    };
                });
                setRows(prevRows => [...prevRows, ...newRows]);
                console.log('newRows', newRows);
            } catch (error) {
                console.error("Error fetching sub-products:", error);
            }
        } else {
            const newRow = {
                id: id,
                productName: productName,
                time: time,
                quantity: "",
            };
            //console.log("new row...", newRow)
            toast.success('Product Added Successfully');
            setRows(prevRows => [...prevRows, newRow]);
        }
    }
    const getTimeData = async () => {
        try {
            const response = await API.getTime();
            setTimeOptions(response?.data?.data || []);
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching time data:", error);
        }
    };

    const bindComboProduct = async (salesTabId) => {
        try {
            const payload = {
                limit: 0,
                is_Active: 1,
                is_combo: true,
                sale_tab_id: salesTabId
            };
            const response = await APISSS.Get_Product_Type(payload);
            setComboProductType(response?.data?.data);
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching combo product:", error);
        }
    };

    const handleCancel = () => {
        window.location.reload();
    }
    const staticHours = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    const staticMinutes = ["0", "15", "30", "45",];

    useEffect(() => {
        if (!fetchDetails) return;
        try {
            // Show correct modal
            setShowComboModal1(fetchDetails.is_combo === true);
            setShowSingleModal1(fetchDetails.is_combo !== true);

            // Common extracted variables
            const typeArray = [{
                id: fetchDetails.product_type_id,
                name: fetchDetails.product_type_name,
            }];
            const arraySalesTab = [{
                id: fetchDetails.sale_tab_id,
                tab_name: fetchDetails.sale_tab_name,
            }];

            setHighlight(true);
            setId(fetchDetails.id);
            setupdateProductType(typeArray);

            setISCombo(fetchDetails.is_combo)
            if (fetchDetails.is_combo) {
                handleAddRow(fetchDetails.id, '', '', 'up')
                setIsEditingCombo(true);
                setSalesTab1(arraySalesTab);
                setSelectcomboSalesTab(fetchDetails.sale_tab_id);
                setSelectedLocation1(fetchDetails.location_id);
                setComboName(fetchDetails.name);
                setComboProductType(typeArray);
                setSelectedcomboProductType(fetchDetails.product_type_id);
                setComboDisplayOrder(fetchDetails.display_order);
                setComboPrice(fetchDetails.amount);
                setComboTax(fetchDetails?.tax_type_id);
                setComboSpecialPrice(fetchDetails?.special_price);

                // window.scrollTo({ top: 500, behavior: "smooth" });
            } else {
                const hours = Math.floor(fetchDetails.time / 60);
                const minutes = fetchDetails.time % 60;

                setIsEditing(true);
                setSalesTab(arraySalesTab);
                setSelectedLocation(fetchDetails.location_id);
                setSelectSalesTab(fetchDetails.sale_tab_id);
                setName(fetchDetails.name);
                setProductType(fetchDetails.product_type_id);
                setDisplayOrder(fetchDetails.display_order);
                setPlayPoint(fetchDetails.amount);
                setDescription(fetchDetails.description);
                setTimeValue(hours);
                setTimeValue1(minutes);
                setMrp(fetchDetails?.mrp)
                setSingleTax(fetchDetails?.tax_type_id)
                setSkycoinsSpcl(fetchDetails?.special_price)
                setIsRecipe(fetchDetails?.is_recipe)
                setTrackInventory(fetchDetails?.track_inventory)
                setCuriousKids(fetchDetails?.expose_api)
                // console.log('dddd',fetchDetails);
                //console.log('fetchDetails?.expose_api',fetchDetails?.["expose_api "] ?? false);
                //    setCuriousKids(fetchDetails?.["expose_api "] ?? false);
                setCuriousKids(fetchDetails?.expose_api ?? false);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            if (error?.response?.status === 403) {
                window.location.replace("/Login");
            }
            toast.error("An error occurred while fetching product details.");
        }
    }, [fetchDetails]);


    const productTypeFlag = false;
    const productTypeFlag2 = 'All';

    const updateProductData = async () => {
        //console.log('isComboisCombo', isCombo);
        const validateFields = () => {
            let errors = [];
            const isNumeric = (value) => !isNaN(value) && String(value).trim() !== '';
            const isValid = (value) => value !== undefined && value !== null && String(value).trim() !== '';
            if (fetchDetails.is_combo) {
                if (!comboName) errors.push("Combo Name is required.");
                if (comboProductType === 'Select') errors.push("Combo Product Type is required.");
                if (comboDisplayOrder === 'Select') errors.push("Combo Display Order is required.");
                if (!isValid(comboPrice) || !isNumeric(comboPrice)) errors.push("Combo Price is required and must be a valid number.");
                // if (comboTime === 'Select') errors.push("Combo Time is required.");
                if (comboTax === 'Select') errors.push("Combo Tax is required.");
            } else {
                if (!name) errors.push("Product Name is required.");
                if (productType === 'Select') errors.push("Product Type is required.");
                if (displayOrder === 'Select') errors.push("Display Order is required.");
                if (skycoinsSpcl === "" || skycoinsSpcl.undefined || skycoinsSpcl === 0)
                    errors.push("SkyCoins (SPCL) is required.");
                if (!isValid(playPoint) || !isNumeric(playPoint)) errors.push("SkyCoins is required and must be a valid number.");
                // if (isRecipe === undefined) errors.push("Recipe flag is required.");
            }
            return errors;
        };

        const errors = validateFields();
        if (errors.length > 0) {
            errors.forEach((error) => toast.error(error));
            return;
        }
        let payload = {};
        if (fetchDetails.is_combo) {

            const comboList =
                rows.map(row => ({
                    id: row.id,
                    qty: row.qty,
                    sub_product_time: parseInt(row.hours || 0) * 60 + parseInt(row.minutes || 0) || row.time,
                    offered_price: row.discounted_price,
                    discounted_price_special: parseFloat(row.discounted_price_special)
                    //sub_product_time: "15"
                }))
            if (comboList.length === 0) {
                toast.error("Please select at least one sub-product.");
                return;
            }
            payload = {
                name: comboName,
                product_type_id: selectedcomboProductType,
                display_order: comboDisplayOrder,
                amount: parseInt(comboPrice) || 0,
                // time: comboTime,
                payment_type_id: 1,
                is_combo: true,
                tax_type_id: null,
                // tax_type_id: comboTax,
                track_inventory: true,
                is_recipe: false,
                description: description,
                mrp: mrp || null,
                special_price: parseFloat(comboSpecialPrice),
                comboList
            };
        } else {
            const timeInMinutes = Number(timeValue) * 60;
            const time = timeInMinutes + Number(timeValue1);
            //  console.log('Converted Time:', time, 'minutes');
            payload = {
                name: name,
                product_type_id: productType,
                display_order: displayOrder,
                amount: playPoint,
                is_recipe: isRecipe ? true : false,
                time: time,
                description: description || "",
                payment_type_id: 1,
                is_combo: false,
                tax_type_id: singleTax,
                //tax_type_id: null,
                // tax_type_id: 1,
                track_inventory: trackInventory ? true : false,
                special_price: parseFloat(skycoinsSpcl),
                mrp: Number(mrp) || null,
                expose_api: curiousKids ? 1 : 0
                // is_party:enableParty
                //is_recipe: isRecipe,
            };
        }
        //console.log('ddddd',payload);
        // return;
        try {
            const response = await API.updateProduct(id, payload);
            if (response?.status === 200) {
                toast.success(response?.data?.message || "Product Status Updated Successfully!");
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update Product. Please try again.");
            }
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.error("Error updating designation:", error?.response?.data?.message);
            toast.error(error?.response?.data?.message);
        }
    };

    return (
        <>
            <div className="container mt-4">

                {showSingleModal1 && (
                    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "#f2edf3" }}>
                        <div className="modal-dialog modal-lg" style={{ border: "1px solid" }}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Edit Single Product Details</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={() => {
                                            setShowSingleModal1(false);
                                            window.location.reload();
                                        }}

                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div className="card-body">

                                        <div className="forms-sample">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddSalesType" className="form-label">
                                                            Center <span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <select className="form-select"
                                                            id="ddSalesType"
                                                            value={selectedLocation}
                                                            onChange={handleChange1}
                                                        >
                                                            <option>Select</option>
                                                            {location.map((item) => (

                                                                <option key={item.id} value={item.id}>
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {error.location && <small className="text-danger">{error.location}</small>}
                                                    </div>

                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddSalesType" className="form-label">
                                                            Sales Tab <span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <select className="form-select"
                                                            id="ddSalesType"
                                                            value={selectSalesTab}
                                                            onChange={handleChange} >
                                                            <option>Select</option>
                                                            {salesTab.map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.tab_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {error.salesTab && <small className="text-danger">{error.salesTab}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <ProductType
                                                            selectedProductType={productType}
                                                            setSelectedProductType={setProductType}
                                                            type={productTypeFlag}
                                                            SalesTab={selectSalesTab}
                                                            updateProductType={updateProductType}
                                                        //onSalesTabChange={handleChange}
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="txtname"
                                                            placeholder="Name"
                                                            value={name}
                                                            onChange={(e) => handleFieldChange(e, "name")}
                                                        />
                                                        {error.name && <small className="text-danger">{error.name}</small>}
                                                    </div>
                                                </div>

                                                <div className="col-md-3">
                                                    <DisplayOrder
                                                        selectedDisplayOrder={displayOrder}
                                                        setSelectedDisplayOrder={(color) => {
                                                            setDisplayOrder(color);
                                                            if (color.trim()) {
                                                                setError((prevErrors) => {
                                                                    const updatedErrors = { ...prevErrors };
                                                                    delete updatedErrors.buttonColor;
                                                                    return updatedErrors;
                                                                });
                                                            }
                                                        }}
                                                    />
                                                </div>

                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label htmlFor="mobile">{changePlayPoint} <span style={{ color: "red" }}>*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="txtmobile"
                                                            placeholder={changePlayPoint}
                                                            value={playPoint}
                                                            onChange={(e) => handleFieldChange(e, "playPoint")}
                                                        />
                                                        {error.playPoint && <small className="text-danger">{error.playPoint}</small>}
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="mrp" className="form-label">
                                                            SkyCoins (SPCL) <span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter SkyCoins Special"
                                                            id="skycoinsSpcl"
                                                            value={skycoinsSpcl}
                                                            onChange={(e) => handleFieldChange(e, "skycoinsSpcl")}
                                                        />


                                                    </div>
                                                </div>

                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <TaxRateListList selectedTaxRate={singleTax} setSelectedTaxRate={setSingleTax}
                                                        taxRates={comboTax}
                                                    />
                                                </div>

                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Enter Hours</label>
                                                        <select
                                                            className="form-select"
                                                            // value={timeValue}
                                                            onChange={(e) => handleFieldChange(e, "timeValue")}
                                                            value={timeValue}

                                                        >

                                                            {staticHours.map((hour) => (
                                                                <option key={hour} value={hour}>
                                                                    {hour} hrs
                                                                </option>
                                                            ))}
                                                        </select>

                                                    </div>
                                                </div>

                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label htmlFor="ddltime" className="form-label">
                                                            Enter Minute
                                                        </label>
                                                        <select
                                                            className="form-select"
                                                            id="ddltime"
                                                            value={timeValue1}
                                                            // onChange={handleFieldChange}
                                                            onChange={(e) => handleFieldChange(e, "timeValue1")}
                                                        >

                                                            {staticMinutes.map((hour) => (
                                                                <option key={hour} value={hour}>
                                                                    {hour} min
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label htmlFor="mrp" className="form-label">
                                                            MRP
                                                        </label>

                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter mrp"
                                                            id="mrp"
                                                            value={mrp}
                                                            onChange={(e) => handleFieldChange(e, "mrp")}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        {/* <label className="form-label">Is Recipe</label> */}
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id="isRecipe"
                                                                checked={isRecipe}
                                                                onChange={() => setIsRecipe(!isRecipe)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="isRecipe"
                                                            >
                                                                Enable Recipe
                                                            </label>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            <div className="row">

                                                {/* <div className="col-md-3">
                                                    <div className="form-group">

                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id="trackInventory"
                                                                checked={trackInventory}
                                                                onChange={() => setTrackInventory(!trackInventory)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="trackInventory"
                                                            >
                                                                Enable Inventory
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="col-md-4">
                                                    <label className="form-label">Expose Api</label>
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input ms-1"
                                                            checked={curiousKids}
                                                            onChange={() => setCuriousKids(!curiousKids)}

                                                        />
                                                        <label className="form-check-label">
                                                            Enable Expose Api
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <div className="form-group">
                                                        <label htmlFor="name">Description</label>
                                                        <textarea
                                                            type="text"
                                                            className="form-control"
                                                            id="txtname"
                                                            placeholder="Description"
                                                            rows={2}
                                                            value={description}
                                                            onChange={(e) => handleFieldChange(e, "description")}
                                                        />
                                                    </div>
                                                </div>
                                            </div>


                                            <button
                                                type="button"
                                                onClick={updateProductData}
                                                className="btn btn-primary me-2"
                                            // style={{ display: isEditing ? "none" : "inline-block" }}
                                            >
                                                Submit
                                            </button>

                                            <button className="btn btn-light" onClick={handleCancel}>Cancel</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showComboModal1 && (

                    <div className="modal show d-block" style={{ backgroundColor: "#f2edf3" }} tabIndex="-1" role="dialog" aria-modal="true">

                        <div className="modal-dialog modal-lg" style={{ border: "1px solid" }}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Edit Combo Product</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        // onClick={() => setShowComboModal1(false)}
                                        onClick={() => {
                                            setShowComboModal1(false);
                                            window.location.reload();
                                        }}
                                    ></button>
                                </div>
                                <div className="modal-body">

                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="ddSalesType" className="form-label">
                                                    Location <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <select className="form-select"
                                                    id="ddSalesType"
                                                    value={selectedLocation1}
                                                    onChange={handleChange3}
                                                >
                                                    <option>Select </option>
                                                    {location1.map((item) => (

                                                        <option key={item.id} value={item.id}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {error.location && <small className="text-danger">{error.location}</small>}
                                            </div>

                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="ddSalesType" className="form-label">
                                                    Sales Tab <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <select className="form-select"
                                                    id="ddSalesType"
                                                    value={selectcomboSalesTab}
                                                    onChange={handleChange2}
                                                >
                                                    <option>Select</option>
                                                    {salesTab1.map((item) => (
                                                        <option key={item.id} value={item.id}>
                                                            {item.tab_name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {error.salesTab && <small className="text-danger">{error.salesTab}</small>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">

                                            <div className="form-group">
                                                <label htmlFor="ddSalesType" className="form-label">
                                                    Product Type <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <select
                                                    className="form-select"
                                                    id="ddSalesType"
                                                    value={selectedcomboProductType}
                                                    onChange={handleChange4}
                                                >
                                                    <option>Select</option>
                                                    {Array.isArray(comboProductType) && comboProductType.map((item) => (
                                                        <option key={item.id} value={item.id}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {error.comboProductType && <small className="text-danger">{error.comboProductType}</small>}
                                            </div>

                                        </div>
                                        <div className="col-md-5">
                                            <div className="form-group">

                                                <label htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="txtname"
                                                    placeholder="Name"
                                                    value={comboName}
                                                    onChange={(e) => handleFieldChange1(e, "comboName")}
                                                />
                                                {error.comboName && <small className="text-danger">{error.comboName}</small>}
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <DisplayOrder
                                                selectedDisplayOrder={comboDisplayOrder}
                                                setSelectedDisplayOrder={(color) => {
                                                    setComboDisplayOrder(color);
                                                    if (color.trim()) {
                                                        setError((prevErrors) => {
                                                            const updatedErrors = { ...prevErrors };
                                                            delete updatedErrors.buttonColor;
                                                            return updatedErrors;
                                                        });
                                                    }
                                                }}
                                            />
                                        </div>


                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label htmlFor="mobile">Price  <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="txtprice"
                                                    placeholder="Price"
                                                    disabled={true}
                                                    value={comboPrice}
                                                    onChange={(e) => handleFieldChange1(e, "comboPrice")}
                                                />
                                                {error.comboPrice && <small className="text-danger">{error.comboPrice}</small>}
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label htmlFor="mobile">Special Price <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="txtSpecialPrice"
                                                    placeholder="Special Price"
                                                    value={comboSpecialPrice}
                                                    disabled={true}
                                                    onChange={(e) => handleFieldChange1(e, "comboSpecialPrice")}
                                                />
                                                {error.comboSpecialPrice && <small className="text-danger">{error.comboSpecialPrice}</small>}
                                            </div>
                                        </div>


                                        {/* <div className="col-md-4">

                                                <TaxRateListList selectedTaxRate={comboTax} setSelectedTaxRate={setComboTax}
                                                    taxRates={comboTax}
                                                />
                                            </div> */}

                                    </div>
                                    {isAddProductList && (
                                        <section >
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered text-center align-middle" style={{ width: "120%" }}>
                                                            <thead className="table-dark">
                                                                <tr>
                                                                    <th style={{ width: "50px" }}>Action</th>
                                                                    <th style={{ width: "150px" }}>Product Name</th>
                                                                    <th style={{ width: "250px" }}>Time</th>
                                                                    <th style={{ width: "100px" }}>Qty</th>
                                                                    <th style={{ width: "30px" }}>Discounted Price</th>
                                                                    <th style={{ width: "30px" }}>Discounted Price(SPCL)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {rows.map((row, index) => (

                                                                    <tr key={index}>
                                                                        <td>
                                                                            <button
                                                                                className="btn btn-danger btn-sm"
                                                                                onClick={() => handleRemoveRow(index)}
                                                                                style={{ backgroundColor: "red" }}
                                                                            >
                                                                                <span className="fa fa-trash-o text-white"></span>
                                                                            </button>
                                                                        </td>
                                                                        <td>{row.productName}</td>
                                                                        <td>
                                                                            {row.time > 0 ? (
                                                                                <span>{`${row.time % 60} min`}</span>
                                                                            ) : (
                                                                                <div className="row">
                                                                                    <div className="col-md-6">
                                                                                        <div className="form-group">
                                                                                            <label>Enter Hours</label>
                                                                                            <select
                                                                                                className="form-select"
                                                                                                value={row.hours}
                                                                                                onChange={(e) => handleInputChange(index, "hours", e.target.value)}
                                                                                            >
                                                                                                {staticHours.map((hour) => (
                                                                                                    <option key={hour} value={hour}>
                                                                                                        {hour} hrs
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-md-6">
                                                                                        <div className="form-group">
                                                                                            <label htmlFor="ddltime" className="form-label">
                                                                                                Enter Minute
                                                                                            </label>
                                                                                            <select
                                                                                                className="form-select"
                                                                                                id="ddltime"
                                                                                                value={row.minutes}
                                                                                                onChange={(e) => handleInputChange(index, "minutes", e.target.value)}
                                                                                            >
                                                                                                {staticMinutes.map((minute) => (
                                                                                                    <option key={minute} value={minute}>
                                                                                                        {minute} min
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </td>

                                                                        <td>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Enter Quantity"
                                                                                value={row.qty}
                                                                                onChange={(e) => handleInputChange(index, "qty", e.target.value)}
                                                                            />
                                                                            {error.qty && <small className="text-danger">{error.qty}</small>}
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Discounted Price"
                                                                                value={row.discounted_price}
                                                                                onChange={(e) => handleInputChange(index, "discounted_price", e.target.value)}
                                                                            />
                                                                            {error.discounted_price && <small className="text-danger">{error.discounted_price}</small>}
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Discounted Price Special"
                                                                                value={row.discounted_price_special}
                                                                                onChange={(e) => handleInputChange(index, "discounted_price_special", e.target.value)}
                                                                            />
                                                                            {error.discounted_price_special && <small className="text-danger">{error.discounted_price_special}</small>}
                                                                        </td>
                                                                    </tr>
                                                                ))}

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <h5>Add SubProduct</h5>
                                                <div className="col-md-4">
                                                    {
                                                        refresh ?
                                                            <ProductType selectedProductType={searchProductType} setSelectedProductType={setSearchProductType} type={productTypeFlag2}
                                                                location_id={selectedLocation1}
                                                            />
                                                            : <></>
                                                    }
                                                </div>
                                                <div className="col-md-3">
                                                    <button className="btn btn-success mt-4"
                                                        type="button"
                                                        onClick={handleSearchClick}
                                                    >Search</button>
                                                </div>
                                            </div>
                                        </section>


                                    )}
                                    {/* Yaha */}
                                    <div className="mt-1"> <button type="button" className="btn btn-primary me-2"
                                        onClick={updateProductData}
                                    >
                                        Update
                                    </button>

                                        <button className="btn btn-light"
                                            onClick={handleCancel}
                                        >Cancel</button></div>


                                </div>
                            </div>
                        </div>
                    </div>

                )}

                {isModal && (
                    <>
                        <div className="modal-backdrop show" style={{ filter: "blur(5px)" }}></div>
                        <section>
                            <div className="modal show d-block" style={{ backgroundColor: "#f2edf3" }} tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered modal-lg" style={{ width: "600px" }}>
                                    <div className="modal-content" style={{ backgroundColor: "#fff" }} >
                                        <div className="modal-header">
                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setIsModal(false)}></button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered text-center">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "100px" }}>SrNo</th>
                                                            <th style={{ width: "200px" }}>Action</th>
                                                            <th>Product Name</th>
                                                            <th>Time</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {searchProductList.map((item, index) => (

                                                            <tr key={item.id}>
                                                                <td>{(currentPage1 - 1) * perPage + index + 1}</td>
                                                                <td>
                                                                    <button className="btn btn-sm btn-success" onClick={() => handleAddRow(item.id, item.name, item.time, 'down')}>Add</button>
                                                                </td>
                                                                <td>{item.name}</td>
                                                                <td>{item.time}</td>

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                <nav aria-label="Page navigation example">
                                                    <ul className="pagination justify-content-center mt-4">
                                                        <li className={`page-item ${currentPage1 === 1 ? "disabled" : ""}`}>
                                                            <button className="page-link" onClick={() => handlePageChange1(currentPage1 - 1)} disabled={currentPage1 === 1}>Previous</button>
                                                        </li>
                                                        {Array.from({ length: totalPages1 }, (_, index) => (
                                                            <li key={index + 1} className={`page-item ${currentPage1 === index + 1 ? "active" : ""}`}>
                                                                <button className="page-link" onClick={() => handlePageChange1(index + 1)}>{index + 1}</button>
                                                            </li>
                                                        ))}
                                                        <li className={`page-item ${currentPage1 === totalPages1 ? "disabled" : ""}`}>
                                                            <button className="page-link" onClick={() => handlePageChange1(currentPage1 + 1)} disabled={currentPage1 === totalPages1}>Next</button>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => setIsModal(false)}>Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                )}

            </div>
        </>
    );
};

export default ComboProduct;
